<template lang="pug">
  .card
    .card-body
      h5.card-title Shared link
      h6.card-subtitle This link can access in 15 day.
      //- .input-group
      input(
        type="text"
        :value="link"
        disabled
        ).form-control
        //- span.input-group-btn
          button(
            v-clipboard:copy="link"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            :disabled="isCopying"
            ).btn.btn-primary {{ btnCopyTxt }}
      button(
        v-clipboard:copy="link"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        :disabled="isCopying"
        ).btn.btn-primary {{ btnCopyTxt }}
      a(
        :href="link"
        target="_blank"
        ).btn.btn-primary Open PDF Link
      //- button(@click.prevent="$emit('onClose')").btn.btn-default Close


</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: 'Loram'
    }
  },

  data () {
    return {
      btnCopyTxt: 'Copy Link',
      isCopying: false
    }
  },

  methods: {
    onCopy: function (e) {
      // alert('You just copied: ' + e.text)
      this.btnCopyTxt = 'Copied'
      this.isCopying = true

      setTimeout(() => {
        this.btnCopyTxt = 'Copy Link'
        this.isCopying = false
      }, 2000)
    },

    onError: function (e) {
      alert('Failed to copy texts')
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  background-color: white;
  width: 100%;
  height: 100%;

  &-body {
    padding: 60px 30px;

    .btn {
      border-radius: 0;
      margin: 0 5px;
    }

    .input-group {
      margin-bottom: 40px;
    }

    .form-control {
      margin-bottom: 40px;
    }
  }

  &-title {
    font-size: 2rem;
  }

  &-subtitle {
    font-size: 1.5rem;
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// sharedLink.vue?c71fc006